webpackJsonp(["conditioner34","conditioner40"],{

/***/ "./src/js/ui/scroll-to.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = scrollTo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__("./src/js/utils.js");


function scrollTo($initiator) {

  var targetId = $initiator.getAttribute('data-scroll-target');
  if (targetId) {
    var $target = document.getElementById(targetId);
    if ($target) {
      $initiator.addEventListener('click', function (e) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils_js__["scrollToElement"])($target, true, 'bottom');
      });
    }
  }
}

/***/ }),

/***/ "./src/js/utils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getOffset"] = getOffset;
/* harmony export (immutable) */ __webpack_exports__["scrollToPosition"] = scrollToPosition;
/* harmony export (immutable) */ __webpack_exports__["scrollToElement"] = scrollToElement;
/* harmony export (immutable) */ __webpack_exports__["isScrolling"] = isScrolling;
var $body = document.body;
var $header = document.getElementById('header');

function getOffset($el) {
  var align = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var bodyRect = $body.getBoundingClientRect();
  var elemRect = $el.getBoundingClientRect();
  var offset = elemRect.top - bodyRect.top;

  if (align === 'top') {
    offset = offset - 30;
  } else if (align === 'middle') {
    offset = offset - window.innerHeight / 2;
  }

  if ($header) {
    offset = offset - $header.getBoundingClientRect().height;
  }

  return offset;
}

function scrollToPosition(y) {
  var smooth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if ('scrollBehavior' in document.documentElement.style) {
    window.scrollTo({
      top: y,
      left: 0,
      behavior: smooth ? 'smooth' : 'auto'
    });
  } else {
    window.scrollTo(0, y);
  }
}

function scrollToElement($el) {
  var smooth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var align = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'top';

  scrollToPosition(getOffset($el, align), smooth);
}

function isScrolling() {
  var top = window.pageYOffset || document.documentElement.scrollTop;
  return top > 0;
}

/***/ })

});


// WEBPACK FOOTER //
// conditioner34.9fdf494e33562a7cafc8.js